export default "__VITE_ASSET__CzuGviQr__"